import { useContext } from "react";
import RequestACallContext from "./RequestACallContext";

const useRequestACall = () => useContext(RequestACallContext);

export default useRequestACall;